<template>
  <a href="#" v-if="button" class="icon icon-button" @click="onIconClick">
    <svg xmlns="http://www.w3.org/2000/svg" :viewBox="`0 0 ${iconObject[0]} ${iconObject[1]}`">
      <path :d="iconObject[4]"></path>
    </svg>
  </a>
  <div v-else class="icon" @click="onIconClick">
    <svg xmlns="http://www.w3.org/2000/svg" :viewBox="`0 0 ${iconObject[0]} ${iconObject[1]}`">
      <path :d="iconObject[4]"></path>
    </svg>
  </div>
</template>

<script>
import {
  faCheck,
  faChevronLeft,
  faChevronRight,
  faCloudUpload,
  faPen,
  faSpinnerThird,
  faTimes as faTimesLight,
  faTrash,
} from '@fortawesome/pro-light-svg-icons';

import { faTimes as faTimesSolid } from '@fortawesome/pro-solid-svg-icons';

const ICONS = {
  // light
  lightIconCheck: faCheck,
  lightIconChevronLeft: faChevronLeft,
  lightIconChevronRight: faChevronRight,
  lightIconCloudUpload: faCloudUpload,
  lightIconPen: faPen,
  lightIconSpinnerThird: faSpinnerThird,
  lightIconTimes: faTimesLight,
  lightIconTrash: faTrash,
  // solid
  solidIconTimes: faTimesSolid,
};

export default {
  name: 'AwesomeIcon',

  props: {
    button: {
      type: Boolean,
      required: false,
      default: false,
    },

    icon: {
      type: String,
      required: true,
    },

    ratio: {
      type: String,
      default: '1',
      required: false,
    },

    type: {
      type: String,
      required: false,
      default: 'light',
    },
  },

  mounted() {
    const svg = this.$el.querySelectorAll('svg');
    if (svg.length) {
      svg[0].setAttribute('height', this.getRatio);
      svg[0].setAttribute('width', this.getRatio);
    }
  },

  computed: {
    getRatio() {
      const parsedRatio = parseFloat(this.ratio, 10) || 1;
      return parsedRatio * 25;
    },

    iconObject() {
      const faType = `${this.type}Icon`;
      const faIcon = this.snakeToCamel(this.icon);
      return ICONS[`${faType}${faIcon}`].icon;
    },
  },

  methods: {
    onIconClick(evt) {
      evt.preventDefault();
      this.$emit('click', evt);
    },
    snakeToCamel(str) {
      const camel = str.replace(/([-_][a-z])/g, group => group.toUpperCase().replace('-', '').replace('_', ''));
      return camel.charAt(0).toUpperCase() + camel.slice(1);
    },
  },
};
</script>
